import { useEffect, useState } from "react";
import { getToken } from "../lib/api";
import { navigate } from "../lib/routes";
import { PageShell } from "./PageShell";

/** Shared read-only API view: never substitute fixture records on failure. */
export function RecordList({ title, subtitle, description, load, columns, empty }) {
  const authenticated = Boolean(getToken());
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (!authenticated) return;
    let active = true;
    setLoading(true);
    load().then(data => {
      if (active) { setRows(data); setError(""); }
    }).catch(err => {
      if (active) { setRows(null); setError(err.message || "Records could not be loaded."); }
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [authenticated, load, revision]);
  return <PageShell title={title} subtitle={subtitle} actions={
    <button className="btn btn-outline" disabled={loading} onClick={authenticated
      ? () => setRevision(value => value + 1)
      : () => navigate("signin")}>{authenticated ? "Refresh" : "Sign in"}</button>
  }>
    <p>{description}</p>
    {!authenticated ? <p role="status">Sign in to view records.</p>
      : loading ? <p role="status">Loading records…</p>
      : error ? <p role="alert">Records unavailable: {error}</p>
      : rows?.length ? <div style={{ overflowX: "auto" }}><table className="table" style={{ width: "100%", textAlign: "left" }}>
        <thead><tr>{columns.map(column => <th key={column.label} scope="col">{column.label}</th>)}</tr></thead>
        <tbody>{rows.map(row => <tr key={row.id}>{columns.map(column => <td key={column.label} style={{ padding: "12px 8px" }}>{column.render(row)}</td>)}</tr>)}</tbody>
      </table></div> : rows ? <p role="status">{empty}</p> : null}
  </PageShell>;
}
